// extracted by mini-css-extract-plugin
export default {"header":"Header_header__BizYJ","logoContainer":"Header_logoContainer__ZD4NC","logo":"Header_logo__inJI0"};